module.exports = __webpack_public_path__ + "static/media/solo52.e0d5a995.JPG";